import { gql, useQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseQuery } from '@/lib/apollo/types'

const getDocumentRequestActivityFeedQuery = gql`
  query (
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $recommendationId: String!
  ) {
    getDocumentRequestActivityFeed(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      recommendationId: $recommendationId
    ) {
      createdAt
      details
      message
      author
    }
  }
`

export interface DocumentRequestActivity {
  createdAt: string
  details: string
  message: string
  author: string
}

export type QueryVars = {
  customerId: string
  applicationId: string
  subjectId: string
  recommendationId: string
}

export type GetDocumentRequestsData = {
  getDocumentRequestActivityFeed: DocumentRequestActivity[]
}

export const useGetDocumentRequestActivityFeedQuery: WrappedUseQuery<
  GetDocumentRequestsData,
  QueryVars
> = options =>
  useQuery<GetDocumentRequestsData, QueryVars>(getDocumentRequestActivityFeedQuery, {
    ...options,
    client: agentClient,
  })
